module.exports = __webpack_public_path__ + "static/cide_talento_300-db2325769ce1d97387908c9f905bc46f.png";